import { keyframes } from '@mui/system'
import { alpha } from '@mui/material/styles'

import theme from 'assets/theme'

export const outlineAnimation = (repeat = 2): string => {
  const outlineKeyframes = keyframes`
      0% {
          outline: 2px solid ${alpha(theme.palette.secondary.main, 0)};
          outline-offset: 8px;
      }
      20% {
          outline: 2px solid ${alpha(theme.palette.secondary.main, 1)};
          outline-offset: 12px;
      }
      100% {
          outline: 2px solid ${alpha(theme.palette.secondary.main, 0)};
          outline-offset: 16px;
      }
  `
  return `${outlineKeyframes} 600ms ease-in-out 0s ${repeat}`
}
